import { flowTypes } from '@/common/service/page-config';
import { translation } from '@/plugins/i18n';
import { logger } from '@/utils/log';
import { dataLayer4Rebranding } from '@zoom/billing-rebranding';
window.dataLayer.push = dataLayer4Rebranding(window.dataLayer.push, window.newBillingConfig.isZoomWorkplaceRebranding);

function getReferrer() {
  const url = window?.newBillingConfig?.referrer;
  const referrerRegExp = {
    'billing': url => /\/billing/.test(url),
    'pricing': url => /\/pricing/.test(url),
  };
  return Object.keys(referrerRegExp).find(k => {
    return referrerRegExp[k](url);
  });
}

const referrer = getReferrer();

const gaFlowTypes = {
  buyNow: 'Direct Purchase',
  basic2pro: 'Free to Paid Upgrade',
  edit: `${referrer} edit`,
  add2cart: `${referrer} new add-ons`,
  pro2biz: 'billing upgrade paid2paid',
  addOnPurchase: 'Add-On Purchase',
  invoiceNoAutopay: 'Invoice No Autopay',
  invoiceWAutopay: 'Invoice with Autopay',
  trial2paid: 'free trial upgrade',
  // FREE TRIAL - url type=add_trial
  [flowTypes.add2trial]: `add free trial`,
}

export const getTrackingFlowType = () => gaFlowTypes[window.$context?.flow];

// customizable raw payload
const EventTracking = (arg) => {
  let payload = arg;
  if (typeof arg === 'function') {
    // use a modifier to reuse the payload
    const basicPayload = {
      flowType: getTrackingFlowType(),
      currencyCode: window.$context?.currency,
    };
    payload = Object.assign(basicPayload, arg(basicPayload));
  }
  logger.table(payload);
  Array.isArray(window.dataLayer) && window.dataLayer.push(payload);
};

const basicFormatter = (...args) => {
  const [event, buyInteraction, buySelection, flowType = getTrackingFlowType()] = args;
  EventTracking({
    event,
    buyInteraction,
    buySelection,
    flowType
  });
};

EventTracking.buyInteraction = (buyInteraction, buySelection, flowType = getTrackingFlowType()) => EventTracking({
  event: 'buyInteraction',
  buyInteraction,
  buySelection,
  flowType,
});

EventTracking.addOnBuyInteraction = (buyInteraction, buySelection, flowType = getTrackingFlowType()) => EventTracking({
  event: 'buyInteraction',
  buyInteraction,
  buySelection,
  flowType: `${flowType} add-ons`,
});

EventTracking.addTrialInteraction = (products, flowType = getTrackingFlowType()) => EventTracking({
  event: 'Product View',
  flowType,
  products
});

EventTracking.addressInteraction = (buySelection, checkbox, flowType = getTrackingFlowType()) => {
  let payload = {
    event: 'buyInteraction',
    buyInteraction: 'checkout address',
    buySelection,
    flowType,
  }
  if (checkbox) payload = Object.assign(payload, {checkbox});
  EventTracking(payload);
}

EventTracking.paymentInteraction = (buySelection, checkbox, flowType = getTrackingFlowType()) => {
  let payload = {
    event: 'buyInteraction',
    buyInteraction: 'checkout payment method',
    buySelection,
    flowType,
  }
  if (checkbox) payload = Object.assign(payload, {checkbox});
  EventTracking(payload);
}

EventTracking.partnerLandingInteraction = (pricingSelection, uiLocation, pricingInteraction = gaFlowTypes.buyNow) => {
  let payload = {
    event: 'pricingInteraction',
    pricingInteraction,
    pricingSelection,
    uiLocation,
  }
  EventTracking(payload);
}

EventTracking.couponInteraction = (buySelection, couponCode, flowType = getTrackingFlowType()) => EventTracking({
  event: 'buyInteraction',
  buyInteraction: 'order summary',
  buySelection,
  couponCode,
  flowType,
});

EventTracking.orderSummary = (buySelection) => basicFormatter('buyInteraction', 'order summary', buySelection)

EventTracking.sign = (accountSelection, accountMethod, modifier) => {
  let payload = {
    event: 'accountInteraction',
    accountInteraction: 'checkout sign up',
    accountSelection,
    flowType: gaFlowTypes[window.$context?.flow],
    accountMethod,
  };
  if (modifier) payload = Object.assign(payload, modifier(payload));
  EventTracking(payload);
}

EventTracking.paymentSwitchType = (paymentType) => EventTracking({
  event: 'Checkout Select Payment Type',
  paymentType,
  flowType: getTrackingFlowType(),
});

EventTracking.postPurchase = (buySelection) => basicFormatter('buyInteraction', 'purchase confirmation', buySelection);

export const mapProducts = (plans, modifier = o => o) => {
  const flowType = getTrackingFlowType();

  return plans.map(x => {
    let product = {
      brand: translation(x?.typeNameKey),
      category: flowType,
      name: translation(x?.planNameKey, [x?.capacity]),
      id: x?.plan_code,
      price: x?.amount / 100,
      list: flowType,
      quantity: x?.cartInfo?.selected_number,
    };
    // FREE TRIAL - different product data
    if(flowType === gaFlowTypes[flowTypes.add2trial]) {
      product = {
        ...product,
        brand: x?.type,
        category: x?.category,
        name: `${product?.brand || this.$t(x?.planNameKey)} Free Trial`, //zoom sessions free trial
        id: x?.plan_code,
        price: product?.price,
      }
    }
    return Object.assign(product, modifier(product, x));
  });
};

export default EventTracking;
